import Map from 'features/Map'

export default ({
  footer = null,
  ...props // header = null, markers = [], onMarkerClick, onMapMounted
}) =>
  <div className="fill-height-container flex text-center">

    {/* <div className="fill-height-header">
        <p className="color-gray text-center text-small">Please contact emergency services or make your way to a nearby emergency room.</p>
      </div> */}

    <div className="fill-height-content">
      <Map {...props} />
    </div>
    <div className="fill-height-footer facility-container">
      { footer }
    </div>
  </div>
